import { User } from '@/models/User';
import axios from 'axios';
import { identifyApplication, identifyHostname } from './Client';
import { Token } from './Token';
export class Auth {
    static loginAs(bearer) {
        Token.set(bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    static async getToken(payload) {
        const headers = {};
        if (window.location.hostname !== 'localhost') {
            headers['X-Application'] = identifyApplication();
        }
        const client = axios.create({
            baseURL: identifyHostname(),
            headers,
        });
        return client.post('/oauth/token', payload);
    }
    static async login(payload) {
        return Auth.getToken(payload)
            .then((response) => {
            if (response.data.access_token) {
                Token.set(response.data.access_token);
                return new User().current();
            }
            return null;
        });
    }
    static async logout() {
        Token.delete();
    }
}
